module.exports = __webpack_public_path__ + "img/trophy.7eda1ddf.svg";